import { propOr, isNil } from "ramda";

import { cache } from "./cache.util";

const { REACT_APP_ATT: r } = process.env;

const keyValueToParamString = ({ key, value }) =>
  `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;

const queryParamsToQueryString = (params) => {
  if (!params) return "";

  return Object.keys(params)
    .reduce((result, key) => {
      const value = params[key];
      return isNil(value)
        ? result
        : result.concat(keyValueToParamString({ key, value }));
    }, [])
    .join("&");
};

const buildUrl = (url, params) => {
  const queryString = queryParamsToQueryString(params);
  return queryString.length === 0 ? url : `${url}?${queryString}`;
};

const getToken = () => {
  try {
    return localStorage.getItem("token");
  } catch (error) {
    console.log({ error });
    return "";
  }
};

const defaultContentTypeHeaders = {
  "content-type": "application/json",
};

const authorizationHeaders = () => ({
  authorization: `Bearer ${getToken()}`,
});

const cacheHeaders = () => ({
  ...cache(r),
});

const getHeaders = (headers) => ({
  ...authorizationHeaders(),
  ...cacheHeaders(),
  ...defaultContentTypeHeaders,
  ...headers,
});

const handleResponse = (res) =>
  res.ok
    ? res.json()
    : res.json().then((responseBody) =>
        Promise.reject({
          url: res.url,
          error:
            propOr(undefined, "error")(responseBody) ||
            propOr(undefined, "Message")(responseBody),
          status: res.status,
          statusText: res.statusText,
        }),
      );

export const postJSON = (url, body, headers) =>
  fetch(url, {
    method: "POST",
    headers: getHeaders(headers),
    body: JSON.stringify(body),
  }).then(handleResponse);

export const putJSON = (url, body, headers) =>
  fetch(`${url}`, {
    method: "PUT",
    headers: getHeaders(headers),
    body: JSON.stringify(body),
  }).then(handleResponse);

export const getJSON = (url, queryParams, headers) => {
  const urlWithQueryParams = buildUrl(url, queryParams);
  return fetch(`${urlWithQueryParams}`, {
    method: "GET",
    headers: getHeaders(headers),
  }).then(handleResponse);
};

export const deleteJSON = (url, queryParams, headers) => {
  const urlWithQueryParams = buildUrl(url, queryParams);
  return fetch(`${urlWithQueryParams}`, {
    method: "DELETE",
    headers: getHeaders(headers),
  }).then(handleResponse);
};
